import React from 'react';
import { formatNowDateTime } from '../../lib/formatDateTime';

/** Live date/time shown in the app shell header (updates every minute). */
export default function PlatformDateTime({ className = '' }: { className?: string }) {
  const [now, setNow] = React.useState(() => formatNowDateTime());

  React.useEffect(() => {
    const tick = () => setNow(formatNowDateTime());
    tick();
    const id = window.setInterval(tick, 60_000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <time
      dateTime={new Date().toISOString()}
      className={`hidden text-xs tabular-nums lg:inline ${className}`}
      style={{ color: 'var(--e2s-muted)' }}
      title="Local date and time"
    >
      {now}
    </time>
  );
}
